import RequestedFeature from '@carvana/merch-contracts/RequestedFeature';

export const baseLimitedRequestFeatures = [
  RequestedFeature.ExcludeFacetData,
  RequestedFeature.HideImpossibleCombos,
  RequestedFeature.LocationBasedPrefiltering
];
